import { useV2ListUsersForAccountQuery } from "@generated";
import { User } from "../types";

const useListUsers = ({ filter, page }) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListUsersForAccountQuery({
      filter,
      page,
      include: ["teams"],
    });

  let users: User[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      users = data?.data.map((user) => {
        const teams =
          user.relationships.teams?.data?.map((team) => {
            const t = data.included?.find(
              (item) => item.type === "teams" && item.id == team.id
            );
            return { value: String(t?.id), label: t?.attributes?.name || "" };
          }) || [];

        return {
          id: Number(user.id),
          active: user.attributes.active || true,
          name: user.attributes.name || "",
          title: user.attributes.title || "",
          email: user.attributes.email || "",
          phone: user.attributes.phone || "",
          createdAt: user.attributes["created-at"] || "",
          teams,
          roles:
            user.attributes?.roles?.map((r) => {
              return { label: String(r.name), value: String(r.id) };
            }) || [],
          userType: user.attributes?.["user-type"] || "",
        };
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }

      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    users,
    usersError: error || customError,
    isLoading,
    isFetching,
    pageMeta,
    refetch,
  };
};

export default useListUsers;
